// shadcn
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'src/@/components/ui/dialog';
import { cn } from 'src/@/lib/utils';
import Iconify from 'src/components/Iconify';
import NovoNegocioForm from './NovoNegocioForm';
import { useEffect, useRef, useState } from 'react';
import v2_actionConfigCrm from 'src/actions/v2/crm/v2_actionConfigCrm';
import { useDispatch } from 'react-redux';
import { getListaColunasCrm, getListaLeads } from 'src/redux/slices/crm';
import v2_actionCriarCrmLead from 'src/actions/v2/crm/v2_actionCriarCrmLead';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import moment from 'moment';

// ----------------------------------------------------------------------

export default function ModalNovoNegocio({
    open,
    onClose,
    chat,
    cliente,
    user
}) {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const [inicial, setInicial] = useState(new Date());
    const [final, setFinal] = useState(new Date());
    const [periodo, setPeriodo] = useState('ultimos_90_dias');

    const [configCrm, setConfigCrm] = useState(null);

    async function buscarConfigCrm(querys) {
        try {
            const result = await v2_actionConfigCrm(cliente._id, querys);
            if (result.data.data) {
                setConfigCrm(result.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (open) buscarConfigCrm(null);
    }, [open]);

    async function handleListaChatsFunil(pipelineId, qualificacao, responsaveis, querysData) {
        try {
            let inicio2 = moment(inicial).format("YYYY-MM-DD");
            let final2 = moment(final).format("YYYY-MM-DD");
            let querys = querysData ? querysData : `?periodo=${periodo}&usuario_id=${user.id}&cliente_id=${user.clienteId}&data_inicial=${inicio2}&data_final=${final2}&pipeline_id=${pipelineId}&qualificacao=${qualificacao}&responsaveis=${responsaveis}`;
            dispatch(getListaLeads(querys));
            dispatch(getListaColunasCrm(querys));
        } catch (error) {
            console.log('error', error);
        }
    }

    const criarNegocio = async (negocio) => {
        try {
            let data = {
                clienteId: cliente._id,
                usuarioId: user.id,
                scope: {
                    nome: negocio.nome,
                    qualificacao: negocio.qualificacao,
                    pipelineId: negocio.pipelineId,
                    pipelineEstagioId: negocio.pipelineStageId,
                    origemId: negocio.origemLead,
                    contatoId: negocio.contatoId,
                    empresa_id: negocio.empresaId,
                    valor: negocio.valor,
                    ...(negocio?.comment ? { comment: negocio.comment } : {})
                }
            };

            await v2_actionCriarCrmLead(data);
            onClose();
            handleListaChatsFunil(negocio.pipelineId, 'all', negocio.responsaveis, null);
        } catch (error) {
            console.log('Error', error);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className={cn("w-full sm:max-w-[480px] p-0 overflow-hidden border-border flex flex-col max-h-[85vh]")}>
                <DialogHeader className="px-6 pt-6 pb-4 border-b bg-background shrink-0">
                    <DialogTitle className="text-xl font-semibold flex items-center gap-2 text-foreground">
                        <Iconify icon="mdi:handshake-outline" className="w-[22px] h-[22px] text-violet-600" />
                        Novo Negócio
                    </DialogTitle>
                </DialogHeader>

                <div className="flex flex-col gap-5 p-6 bg-muted/30 overflow-y-auto flex-1">
                    <NovoNegocioForm
                        ref={formRef}
                        dispatch={dispatch}
                        cliente={cliente}
                        user={user}
                        callbackAddLead={data => criarNegocio(data)}
                        loading={loading}
                        hideActionButtons={true}
                        onSelectPipeline={value => {
                            let querys = `?pipeline_id=${value}`;
                            buscarConfigCrm(querys);
                        }}
                        configCrm={configCrm}
                    />
                </div>

                <div className="px-6 py-4 border-t bg-background shrink-0">
                    <ButtonLoading
                        loading={loading}
                        onClick={() => formRef.current?.submit()}
                        className="w-full h-10 bg-violet-600 hover:bg-violet-700 text-white rounded-md flex items-center justify-center gap-2 transition-all font-medium shadow-sm shadow-violet-500/20 hover:shadow-violet-500/40"
                    >
                        <Iconify icon="mdi:plus" className="w-[18px] h-[18px]" />
                        Criar Lead
                    </ButtonLoading>
                </div>
            </DialogContent>
        </Dialog>
    );
}
